import InfoModal from '@/components/Modals/ModalV2/InfoModal'
import { MODAL_ID } from '@/constants/modalId'
import React from 'react'
import { useArcade } from '../provider'
import CloudinaryImage from '@/components/CloudinaryImage'
import FluidContainer from '@/components/FluidContainer'
import { NextRouter, useRouter } from 'next/router'
import { useAuth } from '@/contexts/auth'
import RankInfoBlock from './RankInfoBlock'
import { determineRank } from '../utils'
import { ModalButtonProps } from '@/components/Modals/ModalV2/types'

const ArcadeClosedCopy = (
  season: number,
  account: string,
  router: NextRouter
): Record<
  'winner' | 'loser',
  {
    title: string
    description: string
    primaryButton: ModalButtonProps
  }
> => {
  const nextSeason = season + 1
  return {
    winner: {
      title: 'You made the top 333!',
      description: `Congrats! You've earned your Freddy Funko as Droppp Monster Redemption Token. Get ready — Season ${nextSeason} is right around the corner!`,
      primaryButton: {
        label: 'Redeem',
        onClick: () => router.push('/redemptions/'),
        theme: 'green-arcade'
      }
    },
    loser: {
      title: 'Better Luck Next Season',
      description: `Get ready — Season ${nextSeason} is right around the corner! In the meantime, show off your Season ${season} participation sticker by applying it to your profile.`,
      primaryButton: {
        label: 'Apply Sticker',
        onClick: () => router.push(`/${account}/?set-avatar=true`),
        theme: 'green-arcade'
      }
    }
  }
}

export default function ArcadeClosedModal() {
  const { season, player, isArcadeLoaded } = useArcade()
  const router = useRouter()
  const { user } = useAuth()
  if (!isArcadeLoaded) return null

  const status = determineRank(player.rank) === 'Eligible' ? 'winner' : 'loser'
  const { title, description, primaryButton } = ArcadeClosedCopy(
    season.id,
    user.account_wax,
    router
  )[status]

  return (
    <InfoModal
      title={title}
      primaryButton={primaryButton}
      secondaryButton={{
        label: 'View Inventory',
        onClick: () => router.push('/inventory/'),
        theme: 'secondary'
      }}
      header={{
        component: (
          <FluidContainer
            targetWidth={480}
            className="w-full aspect-[480/300] bg-error flex items-center p-4"
          >
            <h1
              className="h3 text-arcadeGreen relative z-10"
              style={{ fontSize: '5em' }}
            >
              Season {season.id}
              <br></br>
              <span className="text-white">Closed</span>
            </h1>
            <CloudinaryImage
              layout="fill"
              imageId={'closed'}
              path={'global/modals/arcade/'}
            />
          </FluidContainer>
        )
      }}
      id={MODAL_ID.arcade.closed}
    >
      <div className="space-y-3">
        <p className="text-gray-300">{description}</p>
        <RankInfoBlock label="You Ranked" rank={player.rank} />
      </div>
    </InfoModal>
  )
}
